/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useGetStatements = makeQueryHook(operations.getStatements)

export const useUpdateStatement = makeMutationHook(operations.updateStatement)

export const useInternalCreateStatementDocument = makeMutationHook(
  operations.internalCreateStatementDocument,
)

export const useGetStatementDetails = makeQueryHook(
  operations.getStatementDetails,
)
